import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar from './UserAvatar';
import UserAvatarPopover from '../AvatarPopover';
import { ResourceType } from '../../types/resource';
import { isGroup as getIsGroup } from '../helpers';
import { BiEventType } from '@wix/da-bi/pkg/constants';
export var UserAvatarWithPopover = function (_a) {
    var withTooltip = _a.withTooltip, user = _a.user, className = _a.className, biData = _a.biData, relatedItemBiData = _a.relatedItemBiData, props = __rest(_a, ["withTooltip", "user", "className", "biData", "relatedItemBiData"]);
    var isMobile = useContext(MobileContext);
    var isGroup = user && getIsGroup(user);
    var shouldRenderTooltip = withTooltip && !isMobile && !isGroup;
    if (!shouldRenderTooltip || !user) {
        return (React.createElement(UserAvatar, __assign({ user: user, className: className, biData: biData }, props)));
    }
    return (React.createElement(UserAvatarPopover, { username: user.username, className: className, relatedItemBiData: relatedItemBiData, biData: __assign(__assign({ itemid: user.userId, typeid: isGroup ? ResourceType.GROUP : ResourceType.USER }, biData), { evid: BiEventType.USERNAME_HOVER_TO_OPEN }) },
        React.createElement(UserAvatar, __assign({ user: user, biData: biData }, props))));
};
UserAvatarWithPopover.displayName = 'UserAvatarWithPopover';
export default UserAvatarWithPopover;
//# sourceMappingURL=UserAvatarWithPopover.js.map